export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0a0e27] relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 20% 50%, cyan 1px, transparent 1px), radial-gradient(circle at 80% 80%, purple 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16 relative z-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 mb-8 sm:mb-12">
          <div>
            <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
              <img 
                src="https://static.readdy.ai/image/1a62d479ea6bd5856073579187b5ee28/d89edf7cec4be8a93036cdc06d40ecd0.png" 
                alt="Logo" 
                className="w-8 h-8 sm:w-10 sm:h-10 object-contain"
              />
              <span className="text-lg sm:text-xl font-bold text-white">Agente Inteligente</span>
            </div>
            <p className="text-gray-400 text-sm sm:text-base mb-4 sm:mb-6 leading-relaxed">
              Revolucionando la atención al cliente con inteligencia artificial avanzada.
            </p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="Tu email"
                className="flex-1 bg-[#1a1f3a] border border-cyan-500/30 text-white px-3 sm:px-4 py-2 rounded-lg outline-none focus:border-cyan-500 transition-all duration-300 text-xs sm:text-sm"
              />
              <button className="w-9 h-9 sm:w-10 sm:h-10 bg-gradient-to-r from-cyan-500 to-purple-600 rounded-lg flex items-center justify-center hover:shadow-lg hover:shadow-cyan-500/50 transition-all duration-300 cursor-pointer flex-shrink-0">
                <i className="ri-send-plane-fill text-white text-sm sm:text-base"></i>
              </button>
            </div>
          </div>

          <div>
            <h4 className="text-cyan-400 font-bold mb-3 sm:mb-4 text-base sm:text-lg">Producto</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <button onClick={() => scrollToSection('caracteristicas')} className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 cursor-pointer text-sm sm:text-base">
                  Características
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('casos-uso')} className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 cursor-pointer text-sm sm:text-base">
                  Casos de Uso
                </button>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 text-sm sm:text-base">
                  Precios
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 text-sm sm:text-base">
                  Integraciones
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 text-sm sm:text-base">
                  API
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-cyan-400 font-bold mb-3 sm:mb-4 text-base sm:text-lg">Empresa</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 text-sm sm:text-base">
                  Sobre Nosotros
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 text-sm sm:text-base">
                  Blog
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 text-sm sm:text-base">
                  Carreras
                </a>
              </li>
              <li>
                <button onClick={() => scrollToSection('contacto')} className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 cursor-pointer text-sm sm:text-base">
                  Contacto
                </button>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 text-sm sm:text-base">
                  Prensa
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-cyan-400 font-bold mb-3 sm:mb-4 text-base sm:text-lg">Recursos</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 text-sm sm:text-base">
                  Documentación
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 text-sm sm:text-base">
                  Guías
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 text-sm sm:text-base">
                  Centro de Ayuda
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 text-sm sm:text-base">
                  Comunidad
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 text-sm sm:text-base">
                  Webinars
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-cyan-500/20 pt-6 sm:pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 sm:gap-6">
            <div className="text-gray-500 text-xs sm:text-sm text-center md:text-left">
              © 2025 Agente Inteligente, un producto de Smart Professional Services LLC Todos los derechos reservados.
            </div>

            <div className="flex gap-3 sm:gap-4">
              {[
                { icon: 'ri-facebook-circle-fill', color: 'hover:text-blue-500' },
                { icon: 'ri-twitter-x-fill', color: 'hover:text-gray-300' },
                { icon: 'ri-linkedin-box-fill', color: 'hover:text-blue-600' },
                { icon: 'ri-instagram-fill', color: 'hover:text-pink-500' },
                { icon: 'ri-youtube-fill', color: 'hover:text-red-500' }
              ].map((social, index) => (
                <a
                  key={index}
                  href="#"
                  className={`w-9 h-9 sm:w-10 sm:h-10 rounded-full border border-cyan-500/30 flex items-center justify-center text-gray-400 ${social.color} transition-all duration-300 hover:border-cyan-500 hover:shadow-lg hover:shadow-cyan-500/30`}
                >
                  <i className={`${social.icon} text-lg sm:text-xl`}></i>
                </a>
              ))}
            </div>

            <div className="flex flex-wrap justify-center gap-3 sm:gap-6 text-xs sm:text-sm">
              <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300">
                Privacidad
              </a>
              <span className="text-gray-600">|</span>
              <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300">
                Términos
              </a>
              <span className="text-gray-600">|</span>
              <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
